import styled, { css } from 'styled-components';

export const ModalContent = styled.div`
  width: 100vw;
  max-width: 100%;
`;

export const Title = styled.div`
  font-family: 'Share Tech Mono', monospace;
  font-size: 15px;
  letter-spacing: 2px;
  color: rgba(255, 255, 255, 0.9);
  text-transform: uppercase;
  margin-bottom: 12px;
`;

export const Divider = styled.div`
  height: 1px;
  background: rgba(255, 255, 255, 0.1);
  margin-bottom: 16px;
`;

export const Blocks = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Block = styled.div`
  margin: 16px 0px;

  :first-child {
    margin-top: 0;
  }

  :last-child {
    margin-bottom: 0;
  }
`;

export const BlockTitle = styled.div`
  margin-bottom: 16px;
  font-family: 'Share Tech Mono', monospace;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
`;

export const SlippageControls = styled.div`
  display: flex;
  align-items: center;
`;

export const SlippageLabel = styled.label`
  margin-right: 4px;
`;

export const SlippageValue = styled.div`
  padding: 8px 16px 6px;
  display: flex;
  align-items: center;
  border-radius: 99px;
  background: rgba(255, 255, 255, 0.08);
  font-family: 'Share Tech Mono', monospace;
  font-size: 14px;
  line-height: normal;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  transition: 0.15s;

  &:hover {
    background: rgba(255, 255, 255, 0.14);
  }
`;

export const SlippageRadio = styled.input`
  position: absolute;
  opacity: 0;
  z-index: -1;

  &:checked ~ ${SlippageValue} {
    background: rgba(155, 89, 182, 0.5);
    color: #fff;
  }
`;

export const SlippageInput = styled.input<{ $isWarning: boolean }>`
  width: 100%;
  margin-left: 8px;
  border: none;
  padding: 8px 16px 6px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.04);
  outline: 1px solid rgba(255, 255, 255, 0.1);
  outline-offset: -1px;
  font-family: 'Share Tech Mono', monospace;
  font-size: 14px;
  line-height: normal;
  color: #fff;
  text-align: right;

  /* Hide number input arrows */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  &[type='number'] {
    -moz-appearance: textfield;
  }

  :focus {
    outline-color: rgba(155, 89, 182, 0.6);
  }

  ${(props) =>
    props.$isWarning &&
    css`
      outline-color: rgba(231, 76, 60, 0.6);

      :focus {
        outline-color: rgba(231, 76, 60, 0.8);
      }
    `}

  @media (max-width: 380px) {
    margin-left: 0;
  }
`;

export const SlippagePercent = styled.div`
  margin-left: 4px;
  font-family: 'Share Tech Mono', monospace;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
`;

export const SlippageWarning = styled.div`
  margin-top: 16px;
  display: flex;
  align-items: center;
  font-family: 'Share Tech Mono', monospace;
  font-size: 13px;
  color: rgba(231, 76, 60, 0.9);
`;

export const UsePMM = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const UsePMMIcon = styled.div`
  margin-right: 8px;
  font-size: 19px;
`;

export const UsePMMTexts = styled.div`
  margin-right: 6px;
  flex: 1;
`;

export const UsePMMTitle = styled.div`
  margin-bottom: 6px;
  font-family: 'Share Tech Mono', monospace;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
`;

export const UsePMMText = styled.div`
  font-family: 'Share Tech Mono', monospace;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  line-height: 1.4;
`;

export const UsePMMLabel = styled.label`
  cursor: pointer;
  flex-shrink: 0;
`;

export const UsePMMButtonRound = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 99px;
  position: relative;
  left: 0px;
  transition: 0.3s;
  background: rgba(146, 165, 224, 0.8);
`;

export const UsePMMButton = styled.div`
  width: 52px;
  height: 28px;
  padding: 2px;
  border-radius: 99px;
  background: rgba(255, 255, 255, 0.08);
  transition: 0.3s;

  &:hover {
    background: rgba(255, 255, 255, 0.14);
  }
`;

export const UsePMMInput = styled.input`
  position: absolute;
  opacity: 0;
  z-index: -1;

  &:checked ~ ${UsePMMButton} {
    background: rgba(46, 204, 113, 0.5);

    ${UsePMMButtonRound} {
      left: calc(100% - 24px);
      background: #fff;
    }
  }
`;
